'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = confirm;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function confirm(props) {
	return new _promise2.default(function (resolve, reject) {
		var handleOk = function handleOk() {
			resolve(true);
		};

		var handleCancel = function handleCancel() {
			resolve(false);
		};

		props.onOk = handleOk;
		props.onCancel = handleCancel;

		props.cancelText = props.cancelText || '取消';
		props.okText = props.okText || '确定';

		_modal2.default.confirm(props);
	});
}
module.exports = exports['default'];